import { LandingController } from 'fragments/landing/interfaces';

export const useLandingController = (): LandingController => {
    return {};
};
